import { Button } from "newui/components/Button";
import Tooltip from "newui/components/Tooltip";
import { RFX_TABS } from "utils/constants";
import { ExternalSubmissionButtonsProps } from "./types";

interface SubmissionButtonsProps extends ExternalSubmissionButtonsProps {
	hasSubmitted: boolean;
}

export const SubmissionButtons = ({
	currentTab,
	continueTab,
	hasDeadlinePassed,
	hasSubmitted,
	isLoading,
	revokeSubmissionHandler,
	submitHandler,
	validForm,
}: SubmissionButtonsProps) => {
	const editOrSubmit = hasSubmitted ? "Edit" : "Submit";
	const deadlineTooltip = `Submission deadline has passed. You can no longer ${editOrSubmit} your response.`;
	const submissionTooltip = hasDeadlinePassed
		? deadlineTooltip
		: isLoading
			? "Saving your response, please wait..."
			: !validForm
				? "Please fill all required fields before submitting."
				: `${editOrSubmit} your response to this RFx`;

	const onSubmitClick = () => {
		if (hasDeadlinePassed) {
			return;
		}

		if (hasSubmitted) {
			revokeSubmissionHandler();
		} else {
			submitHandler(currentTab);
		}
	};

	return (
		<>
			{currentTab !== RFX_TABS.ADDENDUMS && !hasSubmitted && (
				<Tooltip
					label={hasDeadlinePassed ? deadlineTooltip : "Continue to next tab"}
				>
					<Button
						type="button"
						btntype="secondary"
						disabled={isLoading || hasDeadlinePassed}
						onClick={() => {
							continueTab();
						}} //
						data-testid="continue-button"
					>
						Save & Continue
					</Button>
				</Tooltip>
			)}
			<Tooltip label={submissionTooltip}>
				<Button
					type="button"
					onClick={onSubmitClick}
					disabled={isLoading || !validForm || hasDeadlinePassed}
					isLoading={isLoading}
					data-testid="submit-button"
				>
					{`${editOrSubmit} Response`}
				</Button>
			</Tooltip>
		</>
	);
};
